export default __webpack_public_path__ + "static/media/jpg.9a6bd112.svg";